import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2cb9246d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  id: "basicLayout"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "basic-background"
}, null, -1));
import GlobalHeader from "@/components/layout/GlobalHeader";
import GlobalFooter from "@/components/layout/GlobalFooter";
import '@/styles/BasicLayout.scss';
import GlobalFixedHeader from "@/components/layout/GlobalFixedHeader.vue";
import { useScroll } from "@vueuse/core";
export default /*#__PURE__*/_defineComponent({
  __name: 'BasicLayout',
  setup(__props) {
    const {
      y
    } = useScroll(window);
    return (_ctx, _cache) => {
      const _component_a_layout_header = _resolveComponent("a-layout-header");
      const _component_router_view = _resolveComponent("router-view");
      const _component_a_layout_content = _resolveComponent("a-layout-content");
      const _component_a_layout = _resolveComponent("a-layout");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(_component_a_layout, null, {
        default: _withCtx(() => [_createVNode(_component_a_layout_header, {
          class: "header"
        }, {
          default: _withCtx(() => [_createVNode(GlobalFixedHeader), _createVNode(_unref(GlobalHeader))]),
          _: 1
        }), _createVNode(_component_a_layout_content, {
          class: "content"
        }, {
          default: _withCtx(() => [_createVNode(_component_router_view)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_unref(GlobalFooter))]);
    };
  }
});